/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigurationHealthRowResponse
 */
export interface ConfigurationHealthRowResponse {
    /**
     * 
     * @type {number}
     * @memberof ConfigurationHealthRowResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHealthRowResponse
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHealthRowResponse
     */
    siteName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHealthRowResponse
     */
    customerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHealthRowResponse
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHealthRowResponse
     */
    linkKind?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigurationHealthRowResponse
     */
    linkId?: number;
}

/**
 * Check if a given object implements the ConfigurationHealthRowResponse interface.
 */
export function instanceOfConfigurationHealthRowResponse(value: object): value is ConfigurationHealthRowResponse {
    return true;
}

export function ConfigurationHealthRowResponseFromJSON(json: any): ConfigurationHealthRowResponse {
    return ConfigurationHealthRowResponseFromJSONTyped(json, false);
}

export function ConfigurationHealthRowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationHealthRowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'label': json['label'] == null ? undefined : json['label'],
        'siteName': json['siteName'] == null ? undefined : json['siteName'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'detail': json['detail'] == null ? undefined : json['detail'],
        'linkKind': json['linkKind'] == null ? undefined : json['linkKind'],
        'linkId': json['linkId'] == null ? undefined : json['linkId'],
    };
}

export function ConfigurationHealthRowResponseToJSON(json: any): ConfigurationHealthRowResponse {
    return ConfigurationHealthRowResponseToJSONTyped(json, false);
}

export function ConfigurationHealthRowResponseToJSONTyped(value?: ConfigurationHealthRowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'siteName': value['siteName'],
        'customerName': value['customerName'],
        'detail': value['detail'],
        'linkKind': value['linkKind'],
        'linkId': value['linkId'],
    };
}

